import Logo from './Logo.png';
import Insurance from './Insurance.png';
import SternLogo from './SternLogo.png';
import Tagesshau from './Tagesshau.png';
import NegativeCurve from './NegativeCurve.png';
import PositiveCurve from './PositiveCurve.png';
import KinderCards from './KinderCards.png';
import AnalyticsSection from './AnalyticsSection.png';
import Focus from './Focus.png';
import InterestRate from './InterestRate.png';
import DrKlein from './DrKlein.png';
import KapitalRoad from './KapitalRoad.png';
import Individuele from './Individuele.png';
import Immobile from './Immobile.png';
import Umzug from './Umzug.png';
import Regelmasige from './Regelmasige.png';
import Renovierung from './Renovierung.png';
import Auto from './Auto.png';
import RoadCalculator from './RoadCalculator.png';
import EstgImage from './EstgImage.png';
import RoadSectionItems from './RoadSectionItems.png';
import Formula from './Formula.png';
import RiskMeasurment from './RiskMeasurment.png';
import Apartment from './Apartment.png';
import RoadmaoNarrow from './RoadmaoNarrow.png';
import Bausparvertrag from './Bausparvertrag.png';
import Verbrauchzentrale from './verbrauchzentrale.png';
import StrasseDesLebens from '../icons/IMG 3.png';
import DiffLogo from './diff-logo.png';
import LogoIcon from './LogoIcon.png';
import ArbeitskraftsicherungIcon from './arbeitskraftsicherung-icon.png';
import PatientDoctor from './Arbeitskraftsicherung-2.png';
import EuroBanknotes from './Arbeitskraftsicherung-1.png';
import VermogensaufbauWhiteIcon from './vermogensaufbau-white.png';
import FruherWhiteIcon from './fruher-white.png';
import ErwerbWhiteIcon from './erwerb-white.png';
import ExistensischerungWhiteIcon from './existen-white.png';
import InstandhaltungsrucklageWhiteIcon from './instand-white.png';
import KinderWhiteIcon from './kinder-white.png';
import KinderBrownIcon from '../icons/tabler_mood-kid (2).svg';
import KinderGreenIcon from '../icons/tabler_mood-kid (1).svg';
import VermogensaufbauBrownIcon from '../icons/mage_chart-up (2).svg';
import VermogensaufbauGreenIcon from '../icons/mage_chart-up (1).svg';
import ErwerbBrownIcon from '../icons/material-symbols_home-outline-rounded (2).svg';
import ErwerbGreenIcon from '../icons/material-symbols_home-outline-rounded (1).svg';
import InstandhaltungsrucklageBrownIcon from '../icons/hugeicons_repair (2).svg';
import InstandhaltungsrucklageGreenIcon from '../icons/hugeicons_repair (1).svg';
import FruherBrownIcon from '../icons/simple-line-icons_check (2).svg';
import FruherGreenIcon from '../icons/simple-line-icons_check (1).svg';
import ExistensischerungBrownIcon from '../icons/mdi_file-document-box-check-outline (2).svg';
import ExistensischerungGreenIcon from '../icons/mdi_file-document-box-check-outline (1).svg';
import ArbeitskraftsicherungBrownIcon from './arbeitskraftsicherung-icon.png';
import ArbeitskraftsicherungGreenIcon from './arbeitskraftsicherung-icon.png';

const Image = {
  Logo,
  Insurance,
  SternLogo,
  Tagesshau,
  NegativeCurve,
  PositiveCurve,
  KinderCards,
  AnalyticsSection,
  Focus,
  InterestRate,
  DrKlein,
  KapitalRoad,
  Individuele,
  Immobile,
  Umzug,
  Regelmasige,
  Renovierung,
  Auto,
  RoadCalculator,
  EstgImage,
  RoadSectionItems,
  Formula,
  RiskMeasurment,
  Apartment,
  RoadmaoNarrow,
  Bausparvertrag,
  Verbrauchzentrale,
  StrasseDesLebens,
  DiffLogo,
  LogoIcon,
  ArbeitskraftsicherungIcon,
  PatientDoctor,
  EuroBanknotes,
  VermogensaufbauWhiteIcon,
  FruherWhiteIcon,
  ErwerbWhiteIcon,
  ExistensischerungWhiteIcon,
  InstandhaltungsrucklageWhiteIcon,
  KinderWhiteIcon,
  KinderBrownIcon,
  KinderGreenIcon,
  VermogensaufbauBrownIcon,
  VermogensaufbauGreenIcon,
  ErwerbBrownIcon,
  ErwerbGreenIcon,
  InstandhaltungsrucklageBrownIcon,
  InstandhaltungsrucklageGreenIcon,
  FruherBrownIcon,
  FruherGreenIcon,
  ExistensischerungBrownIcon,
  ExistensischerungGreenIcon,
  ArbeitskraftsicherungBrownIcon,
  ArbeitskraftsicherungGreenIcon,
};

export type ImageType = keyof typeof Image;

export default Image;
